import { Box, Flex, Icon } from '@chakra-ui/react';
import { ParagraphCommentBoxFragment } from '../../../generated/types';
import { HTMLText } from '../../Common/HTMLText';
import { ImQuotesLeft } from '@react-icons/all-files/im/ImQuotesLeft';
import { ImQuotesRight } from '@react-icons/all-files/im/ImQuotesRight';
import Link from 'next/link';

interface CommentBoxProps {
  data: ParagraphCommentBoxFragment;
}

export const CommentBox: React.FC<CommentBoxProps> = ({ data }) => {
  return (
    <Box
      bg="gray.100"
      border="1px solid"
      borderColor="rgba(0,0,0, .3)"
      borderRadius="md"
      p={6}
      my={4}
      pos="relative"
      width="100%"
    >
      <Icon
        as={ImQuotesLeft}
        pos="absolute"
        left={8}
        top={4}
        zIndex={0}
        fontSize="7rem"
        opacity={0.15}
      />
      {data.title && (
        <Box fontSize="lg" fontWeight="bold" mb={2}>
          {data.title}
        </Box>
      )}
      <HTMLText text={data.text} />

      <Icon
        as={ImQuotesRight}
        pos="absolute"
        right={8}
        bottom={4}
        zIndex={0}
        fontSize="7rem"
        opacity={0.15}
      />

      {(data.author || data.externalAuthor) && (
        <Flex
          justifyContent="flex-end"
          fontWeight="bold"
          pos="relative"
          zIndex={1}
        >
          {data.author && (
            <Box>
              <Link href={data.author.url}>{data.author.title}</Link>
            </Box>
          )}
          {data.externalAuthor && (
            <Box>
              {data.customLink ? (
                <a href={data.customLink} target="_blank">
                  {data.externalAuthor}
                </a>
              ) : (
                data.externalAuthor
              )}
            </Box>
          )}
        </Flex>
      )}
    </Box>
  );
};

export default CommentBox;
